/* eslint-disable @wyz/module/no-relative-import */
import { ConfirmationProvider, ThemeProvider, ToastProvider } from '@wyz/ui';
import { QueryClient, QueryClientProvider } from '@wyz/utils';
import * as React from 'react';
import { BrowserRouter } from 'react-router';
import {
  AnalyticsProvider,
  AuthChecker,
  AuthProvider,
  ConfigProvider,
  DatatableProvider,
  GtmTackingProvider,
  I18nProvider,
  LocaleProvider,
  LoggerProvider,
  useConfig,
} from '~/common/context';

import AppRouter from './app-router';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(_, error) {
        // TODO: until we add the Exception handle to return a proper Error code in case of 403
        return !error.message.includes('Access Denied');
      },
    },
  },
});

const ConfiguredApp = () => {
  const { routingBasename } = useConfig();

  // force redirect to routingBasename if the user, intentionally or not, lands on a path outside of it (in our case / , or /onboarding)
  React.useEffect(() => {
    if (
      routingBasename &&
      !window.location.pathname.startsWith(routingBasename)
    ) {
      const currentPath =
        window.location.pathname === '/' ? '' : window.location.pathname;
      const newPath = `${routingBasename}${currentPath}${window.location.search}${window.location.hash}`;
      window.location.replace(newPath);
    }
  }, [routingBasename]);

  if (
    routingBasename &&
    !window.location.pathname.startsWith(routingBasename)
  ) {
    return null;
  }

  return (
    <LoggerProvider>
      <BrowserRouter basename={routingBasename}>
        <ConfirmationProvider>
          <ThemeProvider>
            <ToastProvider>
              <AnalyticsProvider>
                <AuthProvider>
                  <GtmTackingProvider>
                    <LocaleProvider>
                      <I18nProvider>
                        <AuthChecker>
                          <DatatableProvider>
                            <React.Suspense fallback={null}>
                              <AppRouter />
                            </React.Suspense>
                          </DatatableProvider>
                        </AuthChecker>
                      </I18nProvider>
                    </LocaleProvider>
                  </GtmTackingProvider>
                </AuthProvider>
              </AnalyticsProvider>
            </ToastProvider>
          </ThemeProvider>
        </ConfirmationProvider>
      </BrowserRouter>
    </LoggerProvider>
  );
};

const Main = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <ConfiguredApp />
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default Main;
